import { render, staticRenderFns } from "./BsaHeader.vue?vue&type=template&id=68cb0f5c"
import script from "./BsaHeader.vue?vue&type=script&lang=js"
export * from "./BsaHeader.vue?vue&type=script&lang=js"
import style0 from "./BsaHeader.vue?vue&type=style&index=0&id=68cb0f5c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cb0f5c')) {
      api.createRecord('68cb0f5c', component.options)
    } else {
      api.reload('68cb0f5c', component.options)
    }
    module.hot.accept("./BsaHeader.vue?vue&type=template&id=68cb0f5c", function () {
      api.rerender('68cb0f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/bsa/BsaHeader.vue"
export default component.exports